import "./styles.scss";
import React, { CSSProperties, type ReactNode, useMemo } from "react";
import { buildCls } from "../../utils/helpers/buildCls";

interface Props<T> {
  id?: string;
  keyPrefix: string;
  headers?: ReactNode;
  children?: ReactNode;
  className?: string;
  border?: boolean;
  style?: CSSProperties;
}

export default function KC_Table<T>(props: Props<T>) {
  const clsName: string = useMemo(() => {
    const cls: (string | undefined | Boolean)[] = [
      "kc-table",
      props.className ?? "",
      props.border ? "show-border" : "no-border"
    ];

    return buildCls(cls);
  }, [props.className, props.border]);

  const style = useMemo(() => {
    return {
      minHeight: 150,
      width: "100%",
      overflow: "auto",
      ...(props.style || {})
    };
  }, [props.style]);

  return (
    <div style={style}>
      <table id={props.id} className={clsName}>
        <thead>{props.headers}</thead>
        <tbody>{props.children}</tbody>
      </table>
    </div>
  );
}
